import * as React from 'react'
import { Modal, Button, Alert, message } from 'antd'
import { parseErrorMsg } from '../../../../utilities/helpers'
import { API } from '@getgreenline/homi-shared'

interface Props {
  companyId: number
  onClose: () => void
  onSubmit: () => void
}

interface State {
  isSubmitting: boolean
}

export class CancelAllModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSubmitting: false,
    }
  }

  async submit() {
    try {
      this.setState({ isSubmitting: true })
      await API.deleteAllPaymentQueues(this.props.companyId)
      this.props.onSubmit()
    } catch (error) {
      this.setState({ isSubmitting: false })
      message.error(parseErrorMsg(error))
    }
  }

  render() {
    return (
      <Modal
        title='Clear all'
        visible={true}
        onCancel={this.props.onClose}
        footer={[
          <Button onClick={this.props.onClose} key='cancel' style={{ marginRight: 5 }}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='danger'
            onClick={() => this.submit()}
            loading={this.state.isSubmitting}
          >
            Clear all
          </Button>,
        ]}
      >
        <Alert
          showIcon
          type='error'
          message='The following actions are not reversible. Are you sure?'
          description={
            <ul className='pl-0 no-margin-list'>
              <li>
                This will clear all <b>order placed</b> parked sales for all locations.
              </li>
              <li>
                Pre-paid online parked sales will <b>not</b> be cleared.
              </li>
            </ul>
          }
        />
      </Modal>
    )
  }
}
